//////// POINTS MAP EXAMPLE ///////////////////////

// for mobile view - bound to LA city
// export const BOUNDS_SMALL = [-118.965411, 33.72144, -117.81778, 34.285528];
// // for desktop view - bound to LA city - WSEN
// export const BOUNDS_LARGE = [-119.25658, 33.5024226, -116.841974, 34.29202];

// // from mapbox
// export const STYLE = `mapbox://styles/latimes/cmdpbmzct00fk01rh3vn9g2xa${
//   process.env.NODE_ENV === 'development' ? '/draft' : ''
// }`;
// export const TILESET = 'mapbox://latimes.cnc-2022-plants';

// // this can be found on your tileset - on the right rail, look for "Vector layers" - there should be a name of the source layer right under that label
// export const SOURCE_LAYER = 'plants2022';

// // you can leave these as is or create a new source name if you want
// export const SOURCE = 'source';
// export const TOKEN =
//   'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

////////// SHAPES MAP EXAMPLE ////////////////////////////////////
export const BOUNDS_SMALL = [-118.965411, 33.72144, -117.81778, 34.285528];
export const BOUNDS_LARGE = [-119.25658, 33.5024226, -116.841974, 34.29202];

export const STYLE = `mapbox://styles/latimes/cmdpbmzct00fk01rh3vn9g2xa${
  process.env.NODE_ENV === 'development' ? '/draft' : ''
}`;
export const TILESET = 'mapbox://latimes.8vni81d0/';
export const SOURCE_LAYER = 'totals_zip_map';
export const SOURCE = 'source';
export const TOKEN =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';
